const INITIAL_STATE = {
    menuSelected: '',
    submenuSelected: '',
    drawerOpen: false,
    menuTreeOpen: '',
    menuFloatOpen: {}
}

export default function Menu(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'MENU_CHANGED':
            return { ...state, menuSelected: state.menuSelected === action.payload ? '' : action.payload }
        case 'SUBMENU_CHANGED':
            return { ...state, submenuSelected: action.payload }
        case 'HANDLE_MENUTREE':
            return { ...state, menuTreeOpen: state.menuTreeOpen === action.payload ? '' : action.payload }
        case 'HANDLE_MENUFLOAT':
            return { ...state, menuFloatOpen: action.payload }
        case 'HANDLE_DRAWER':
            return { ...state, drawerOpen: !state.drawerOpen }
        default:
            return state
    }
}